import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { IoMail } from "react-icons/io5";
import { FaLinkedinIn, FaGithub } from "react-icons/fa";
import type { IconType } from "react-icons";

interface ContactLink {
  label: string;
  href: string;
  icon: IconType;
  softColor: string;
  brightColor: string;
}

const links: ContactLink[] = [
  {
    label: "Email Bekah",
    href: "mailto:hi@bekahjune.com",
    icon: IoMail,
    softColor: "#EFEBFE",
    brightColor: "#8B7FFC",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/bekahjune",
    icon: FaLinkedinIn,
    softColor: "#EAF2FE",
    brightColor: "#3B82F6",
  },
  {
    label: "GitHub",
    href: "https://github.com/bekahjune",
    icon: FaGithub,
    softColor: "#E4F6EB",
    brightColor: "#34C77B",
  },
];

const Contact = () => {
  return (
    <Layout>
      <SEO
        title="Hello"
        description="Get in touch with Bekah June — email, LinkedIn, GitHub."
        type="website"
        url="/contact"
        keywords={["contact", "Bekah June", "email", "LinkedIn", "GitHub"]}
      />
      <section className="px-4 sm:px-6 py-6 sm:py-10">
        <div className="w-full max-w-2xl mx-auto font-system">
          <header className="mb-10 md:mt-6">
            <h1 className="text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[1.2] tracking-tight mb-4 text-[#000000]">
              Hello
            </h1>
            <p className="text-base sm:text-lg text-[#000000]/75 leading-[1.6] mb-4">
              If you'd like to reach out please do!
            </p>
            <p className="text-base sm:text-lg text-[#000000]/65 leading-[1.6]">
              You can find my current and previous work history on my LinkedIn. If you'd
              like to see what I've been building, head to my GitHub. And if you'd like
              to drop a note, feel free to email me.
            </p>
          </header>

          <ul className="flex items-center justify-center sm:justify-start gap-5 sm:gap-6">
            {links.map((link) => {
              const Icon = link.icon;
              const isExternal = link.href.startsWith("http");
              return (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={isExternal ? "_blank" : undefined}
                    rel={isExternal ? "noopener noreferrer" : undefined}
                    aria-label={link.label}
                    className="group flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-full transition-transform duration-200 hover:scale-105"
                    style={{ backgroundColor: link.softColor }}
                  >
                    <Icon
                      className="w-[18px] h-[18px] sm:w-5 sm:h-5"
                      style={{ color: link.brightColor }}
                    />
                  </a>
                </li>
              );
            })}
          </ul>

          <p className="mt-12 text-xs text-[#000000]/45 leading-relaxed">
            I do not respond to spam or solicitation, and you will be reported and blocked.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
